import { NodeVariants } from 'features/co-pilot/co-pilot.types';
import _ from 'lodash';
import { Node } from 'reactflow';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface CampaignNodeStore {
  selectedNode: Node | null;
  isPromptChanging: boolean;

  setSelectedNode: (node: Node | null) => void;

  setIsPromptChanging: (newValue: boolean) => void;
}

const useCampaignNodeStore = createWithEqualityFn<CampaignNodeStore>(
  (set) => ({
    selectedNode: null,
    isPromptChanging: false,

    setSelectedNode(node: Node | null) {
      if (!_.isNil(node) && node.type === NodeVariants.FUNCTION_NODE) {
        set(() => ({ selectedNode: node }));
      } else {
        set(() => ({ selectedNode: null }));
      }
    },

    setIsPromptChanging(newValue: boolean) {
      set(() => ({ isPromptChanging: newValue }));
    },
  }),
  shallow
);

export default useCampaignNodeStore;
